import React from "react";
import PRO3BuildBrandFlow from "./brand_widgets/PRO3BuildBrandFlow"
import CUBuildBrandFlow from "./brand_widgets/CUBuildBrandFlow"
import UCBuildBrandFlow from "./brand_widgets/UCBuildBrandFlow"

const BuildBrandFlow = props => {
  
  if (
    props.type == "HCU" ||
    props.type == "VCU" ||
    props.type == "DVCU" ||
    props.type == "VCU_DVCU" ||
    props.type == "HTS"
  ) {
    return <CUBuildBrandFlow {...props}></CUBuildBrandFlow>;
  } else if (
    props.type == "LOP" ||
    props.type == "CM" ||
    props.type == "LVCM" ||
    props.type == "LUC" ||
    props.type == "MP"
  ) {
    return <UCBuildBrandFlow {...props}></UCBuildBrandFlow>;
  } else if (
    props.type == "PRO3" 
    // &&
    // typeof props.modelnumber != "undefined" &&
    // props.modelnumber !== "Call Factory"
  )
    return <PRO3BuildBrandFlow {...props}></PRO3BuildBrandFlow>;
  else return <div></div>;
};

export default BuildBrandFlow;
